module.exports = "/images/vendor/desiigner-svg/svg/logos/18app.svg?e82314c6dbd47a640f1bb905e3fa48ee";